import { render, staticRenderFns } from "./ExchangePreview.vue?vue&type=template&id=2901ca0f&scoped=true"
import script from "./ExchangePreview.vue?vue&type=script&lang=js"
export * from "./ExchangePreview.vue?vue&type=script&lang=js"
import style0 from "./ExchangePreview.vue?vue&type=style&index=0&id=2901ca0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2901ca0f",
  null
  
)

export default component.exports